import { useTranslation } from "react-i18next";
import {
    TEXT_FIELD_TYPE,
} from "../../helpers/constants";
import { IconButton } from "@mui/material";
import { useDialogBetter } from "../../hooks/useDialogBetter";
import EditIcon from '@mui/icons-material/Edit';

import { ClientPassportButton } from "../../components/buttons/ClientPassportButton";

export const TABLE_NAME = "customer_symfonia_code_table";

import { EditCustomerSymfoniaCodeDialog } from "./EditCustomerSymfoniaCodeDialog";

export const useTableFieldsConfig = () => {
    const { t } = useTranslation();

    const { openDialog: openEditCustomerSymfoniaCodeDialog } = useDialogBetter();
    
    const handleClickOpenEditCustomerSymfoniaCodeDialog = (e, data) => {
    e.stopPropagation();
    e.preventDefault();
    openEditCustomerSymfoniaCodeDialog({
        Component: EditCustomerSymfoniaCodeDialog,
        componentProps: {
            id: data.id,
            customerName: data.common_name,
            customerSymfoniaCode: data.customer_symfonia_code,
        },
    });
    };

    return [
        {
            name: "common_name",
            getValueCallback: (rowData) => rowData.common_name,
            label: t("bankings.customer_name"),
            filterType: TEXT_FIELD_TYPE,
            other_export_field_name: "common_name",
            sortable: false,
        },
        {
            name: "customer_symfonia_code",
            getValueCallback: (rowData) => rowData.customer_symfonia_code,
            label: t("bankings.symfonia_code"),
            filterType: TEXT_FIELD_TYPE,
            sortable: false,
        },
        {
            name: "passport",
            getValueCallback: (rowData) =>                         
                    <ClientPassportButton
                    clientId={rowData.id}
                    clientType={rowData.customer_type}
            />,
            label: t("bankings.customer_passport"),
            getFilterFieldConfigCallback: () => undefined,
            sortable: false,
            excludedFromExport: true,
        },
        {
            name: "edit",
            label: t("edit"),
            getValueCallback: (rowData) => (
                <IconButton
                    color={"primary"}
                    onClick={(e) => handleClickOpenEditCustomerSymfoniaCodeDialog(e, rowData)}
                >
                <EditIcon />
                </IconButton>
            ),
            allowChangeVisibility: false,
            excludedFromExport: true,
        },
    ];
};
                        